import { mapActions, mapGetters } from 'vuex'
import servicesData from '../services/services.data'
import servicesUser from '../services/services.user'

const core = {
  data () {
    return {
      imageRoot: process.env.VUE_APP_IMAGE_ROOT,
    }
  },
  computed: {
    ...mapGetters({
      sysClock: 'sysClock',
      jobRunning: 'jobRunning',
      loggedIn: 'loggedIn',
      isAuthenticated: 'isAuthenticated'
    })
  },
  methods: {
    ...mapActions({
      setIsAuthenticated: 'setIsAuthenticated',
      setJobRunning: 'setJobRunning',
      setSysClock: 'setSysClock',
      setLoggedIn: 'setLoggedIn'
    }),
    formatBytes (bytes) {
      if (bytes === 0) return '0 Bytes';

      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      const value = bytes / Math.pow(k, i);
      return `${value.toFixed(2)} ${sizes[i]}`;
    },
    async jobCheck () {
      try {
        this.setJobRunning(await servicesData.jobCheck())
      } catch {
        console.log('problem')
      }
    },
    async verified () {
      console.log (await servicesUser.verifyUser())
      return await servicesUser.verifyUser()
    }
  }
}

export default core